import IntervalTreeWrapper, { IntervalTree } from 'node-interval-tree';

export class IntervalTreeService extends IntervalTreeWrapper {
    seedTree(annotations) {
        annotations.forEach(({ onset, duration, id }) => {
            this.insert(onset, onset + duration, id);
        });
    }

    removeFromIntervalTree({ onset, duration, id }) {
        this.remove(onset, onset + duration, id);
    }

    updateIntervalTree(prev, next) {
        this.remove(prev.onset, prev.onset + prev.duration, prev.id);
        this.insert(next.onset, next.onset + next.duration, next.id);
    }

    addToIntervalTree({ onset, duration, id }) {
        this.insert(onset, onset + duration, id);
    }

    reset() {
        this.tree = new IntervalTree();
    }
}

const intervalTreeService = new IntervalTreeService();

export default intervalTreeService;
